var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-breadcrumb"},[_c('v-breadcrumbs',{attrs:{"items":_vm.crumbs,"dark":""},scopedSlots:_vm._u([{key:"divider",fn:function(){return [_c('v-icon',[_vm._v("mdi-chevron-right")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }